import { MediaApiGateway } from "@modules/common/media/api/mediaApiGateway"
import { MediaUploadInformation } from "@modules/common/media/mediaTypes"
import { Config } from "@modules/config"
import { ApiClient } from "@modules/core/api/client/apiClient"

export class MediaApi implements MediaApiGateway {
  constructor(private api: ApiClient) {}

  async getUploadInformation(mediaType: string) {
    const resultDto = await this.api.post<MediaUploadInformation>(Config.AWS_VIDEO_UPLOAD, {
      contentType: mediaType,
    })
    return resultDto.data
  }

  async uploadFile(file: File, uploadInformation: MediaUploadInformation) {
    const data = {
      ...uploadInformation.data.fields,
      file,
    }
    const formData = new FormData()

    for (const name in data) {
      formData.append(name, data[name])
    }

    await fetch(uploadInformation.data.url, {
      method: "POST",
      body: formData,
    })
  }
}
